@switch ($safeNavigationMigration(device?.Type)) {
  @case (DeviceType.BACnet) {
    <motn-bacnet-point-discovery
      [selectionMode]="true"
      [preselectedDevice]="device.ID"
      [customCallback]="bacnetCallback"
      (clickedOutside$)="closed$.emit()"
    ></motn-bacnet-point-discovery>
  }
  @case (DeviceType.Modbus) {
    <motn-modbus-point-editor
      [selectionMode]="true"
      [preselectedDevice]="device.ID"
      [customCallback]="modbusCallback"
      (clickedOutside$)="closed$.emit()"
    ></motn-modbus-point-editor>
  }
  @case (DeviceType.LoRaWAN) {
    <motn-lorawan-points
      [selectionMode]="true"
      [preselectedDevice]="device.ID"
      [customCallback]="lorawanCallback"
      (clickedOutside$)="closed$.emit()"
    ></motn-lorawan-points>
  }
}
